// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3kR-6","header":"MergedInvoice_header__mUDMO"};